// Service for transaction file operations involving external systems (Drive).
// Simple DB updates (approve, reject, change type/status) use useUpdate directly in FE.
// This service handles operations that require Drive API calls via edge functions.

import { TransactionFileDao } from './TransactionFileDao.ts';
import type { AssignExtractionResult, GoogleEdgeFnClient } from '../edgeFn/GoogleEdgeFnClient.ts';

export class TransactionFileService {
  constructor(
    private dao: TransactionFileDao,
    private googleClient: GoogleEdgeFnClient,
  ) {}

  /** Move file to a different transaction's folder on Drive + update DB.
   *  Used when admin reassigns a file from one transaction to another. */
  async moveFileToTransaction(fileId: number, targetTransactionId: number): Promise<void> {
    await this.googleClient.moveFileToTransaction(fileId, targetTransactionId);
  }

  /** Atomic manual assign of an unmatched extraction to a transaction: records
   *  the extraction match AND files the document (Drive move + DB) in ONE
   *  server-side action. Replaces the old two-write FE flow (kills F8). */
  async assignExtraction(
    extractionId: string,
    targetTransactionId: number,
  ): Promise<AssignExtractionResult> {
    return this.googleClient.assignExtraction(extractionId, targetTransactionId);
  }
}
